function safeJsonParse(value, fallback) {
	if (!value || typeof value !== "string") return fallback;
	try {
		return JSON.parse(value);
	} catch (_error) {
		return fallback;
	}
}

function toArray(value) {
	if (!value) return [];
	return Array.isArray(value) ? value : [value];
}

function normalizeHostname(hostname) {
	return (hostname || "").toString().trim().toLowerCase();
}

function getDefaultBrand() {
	const origin = window?.location ? window.location.origin : "";
	return {
		siteName: process.env.VUE_APP_SITE_NAME,
		logo: process.env.VUE_APP_LOGO_PATH,
		logoAlt: process.env.VUE_APP_LOGO_ALT_PATH,
		favicon: process.env.VUE_APP_FAVICON,
		bannerHome: process.env.VUE_APP_BANNER_HOME,
		linkBannerHome: process.env.VUE_APP_LINK_BANNER_HOME,
		appUrl: origin ? `${origin}/` : process.env.VUE_APP_APP_URL,
	};
}

function getRules() {
	const raw = process.env.VUE_APP_BRANDS;
	const parsed = safeJsonParse(raw, []);
	return Array.isArray(parsed) ? parsed : [];
}

function matchesRule(hostname, rule) {
	const normalizedHostname = normalizeHostname(hostname);
	const hosts = toArray(rule.hosts).map(normalizeHostname).filter(Boolean);
	if (hosts.length && hosts.includes(normalizedHostname)) return true;

	const includes = toArray(rule.includes ?? rule.match)
		.map((v) => (v || "").toString().trim().toLowerCase())
		.filter(Boolean);
	if (
		includes.length &&
		includes.some((token) => normalizedHostname.includes(token))
	)
		return true;

	return false;
}

export function getBranding(hostname) {
	const resolvedHostname =
		hostname ?? (window?.location ? window.location.hostname : "");

	const defaults = getDefaultBrand();
	const rule = getRules().find((r) => r && matchesRule(resolvedHostname, r));
	if (!rule) return defaults;

	return {
		...defaults,
		...rule,
	};
}
